import { WPApi } from "../common/wp-api";

const wp = new WPApi();
import { isMobile } from "../common/utils";


jQuery(document).ready(async ($) => {
    let showsContainer = $('.all-channels-container');

    $(document).on('click', '.channel-name-wrapper img', function () {
        let channel = $(this).attr('alt');

        sport1Analytics.sendEvent('tv-schedule', 'channels-logo-click', channel);
    })

    $(document).on('click', '.show-container', function () {
        let title = $('.show-name', this).text().trim();

        sport1Analytics.sendEvent('tv-schedule', 'game-click', title);
    })


    $('.day-wrapper-link').click(async function (element) {
        let day = $(this).text().trim();
        sport1Analytics.sendEvent('tv-schedule', 'day-click', day);

        if (!$(this).parent().hasClass('selected')) {
            $('.day-wrapper.selected').removeClass('selected');
            $(this).parent().addClass('selected');
            let daySelected = element.currentTarget.id;
            let urlRequest = '';

            const urlParams = new URLSearchParams(window.location.search);
            const currentChannelId = urlParams.get('channel_id');

            if (currentChannelId) {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/channel/' + currentChannelId;
                window.history.pushState('', '', '?day_selected=' + daySelected + '&channel_id=' + currentChannelId);
            } else {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/?live=1';
                window.history.pushState('', '', '?day_selected=' + daySelected + '&live=1');
            }

            let shows = await wp.get(urlRequest);
            if (shows) {
                showsContainer.hide();
                showsContainer.html('');
                showsContainer.append(shows);
                showsContainer.fadeIn();

                // Ensure channel-2 is last after content refresh
                moveChannelTwoToEnd(showsContainer);
            }
        }
    });

    $('.channel-wrapper-link').click(async function () {
        let channelSelected = this.id;

        let channel = $(this).text().trim();
        let analyticsAction;


        if (channelSelected === 'all') {
            analyticsAction = 'all-channels-click';
        } else {
            analyticsAction = 'channel-click';
        }

        sport1Analytics.sendEvent('tv-schedule', analyticsAction, channel);

        if (!$(this).children(0).hasClass('selected')) {


            if (isMobile()) {
                orderChannelsInCollapseElement(this);
            } else {
                $('.channel-wrapper.selected').removeClass('selected');
                $(this).children(0).addClass('selected');
            }

            let urlRequest = '';
            let daySelected = $('.day-wrapper.selected').attr('data-date');
            if (channelSelected !== 'all') {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/channel/' + channelSelected;
                window.history.pushState('', '', '?day_selected=' + daySelected + '&channel_id=' + channelSelected);
            } else {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/?live=1';
                window.history.pushState('', '', '?day_selected=' + daySelected + '&live=1');
            }
            let shows = await wp.get(urlRequest);
            if (shows) {
                showsContainer.hide();
                showsContainer.html('');
                showsContainer.append(shows);
                showsContainer.fadeIn();

                // Ensure channel-2 is last after content refresh
                moveChannelTwoToEnd(showsContainer);

                const $banners = $('.ad', showsContainer);

                const slots = $banners.map(function () {
                    return window[$(this).attr('id')];
                }).toArray();

                googletag.cmd.push(function () {
                    googletag.pubads().refresh(slots);
                });
            }
        }
    });

    $('.btn-primary').click(function () {
        let image = $('#channels-image-arrow-down');
        if (image.hasClass('selected')) {
            image.removeClass('selected');
        } else {
            image.addClass('selected');
        }
    });

});

function moveChannelTwoToEnd(container) {
    // Work inside the inner .col-12 wrapper (not next to it)
    let $inner = $('> .col-12', container).first();
    if ($inner.length === 0) {
        $inner = container;
    }

    const $channelTwo = $('#channel-1-container', $inner);
    if (!$channelTwo.length) return;

    // Place after the last channel-container to keep banners positioning intact
    const $lastChannel = $('.channel-container', $inner).last();
    if ($lastChannel.length) {
        $channelTwo.insertAfter($lastChannel);
    } else {
        $channelTwo.appendTo($inner);
    }
}

function orderChannelsInCollapseElement(element) {
    let collapseOpenerButtonText = $('.btn-primary-text');
    let collapseOpenerButtonElement = $('.btn-primary');
    let channelSelectedTextElement = $('.channel-wrapper-title', element);

    let previousChannelName = collapseOpenerButtonText.text();
    let previousChannelId = collapseOpenerButtonElement.attr('id');
    let channelName = channelSelectedTextElement.text();

    collapseOpenerButtonText.text(channelName);
    collapseOpenerButtonElement.attr('id', element.id);
    element.id = previousChannelId;
    channelSelectedTextElement.text(previousChannelName);
    channelSelectedTextElement.attr('data-channel-id', previousChannelId);

    // Sort mobile channels by displayed name
    let displayOrderByName = {
        'שידורים ישירים': 0, 'ספורט 1': 1, 'ספורט 2': 2, 'ספורט 3': 3, 'ספורט 4': 4, 'ספורט 6': 5
    };
    $('#collapseExample .channel-wrapper-link.d-lg-none').each(function () {
        let channelText = $('.channel-wrapper-title', this).text().trim();
        let order = displayOrderByName[channelText];
        if (order === undefined) order = 99;
        $(this).css('order', order);
    });
}
